import { useState } from "react"
import { useLocation } from "react-router-dom";
import { Box, Grid, Menu, MenuItem, Typography, useTheme } from "@mui/material"
import { styled } from "../../../../theme";
import MenuGroupIcon from '../../../../assets/icons/icon_menu_group';
import D24MenuIcon from '../../../../assets/icons/icon_ds24_menu_item';
import { AppLogo } from '../../../../AppLogo'
import { servicesList } from "../../../../helpers/services.data"


function LoginHeader({ title = 'Вход в систему' }) {
  const theme = useTheme();
  const location = useLocation()

  const ref = new URLSearchParams(location.search).get("ref") || "d24";
  const currentServiceIdx = servicesList.findIndex(serviceRoute => serviceRoute.name === ref)

  const [anchorEl, setAnchorEl] = useState(null);
  const [currentServiceId, setCurrentServiceId] = useState(currentServiceIdx);

  const open = Boolean(anchorEl);
  const currentService = servicesList[currentServiceId];


  const handleMenuChange = async (index, name) => {
    setCurrentServiceId(index) 
    setAnchorEl(null)
    const url = new URL(window.location.href);

    name === 'd24' ? url.search = '' : url.searchParams.set('ref', name) 
    window.history.pushState({}, '', url.toString());
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3.5 }}>
    <Grid sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
      <Grid sx={{ display: 'flex', alignItems: 'center', gap: 2.5 }}>
        <Box sx={{ '& svg': { width: { xs: 92, md: 115 }, height: 'auto', cursor: 'default' } }}><AppLogo /></Box>  
        <Grid>
          <Typography sx={{ fontWeight: 700, pb: 0.2 }}>{currentService.title}</Typography>
          <Typography sx={{ color: theme.palette.grey.main, fontSize: 14 }}>{currentService.note}</Typography>
        </Grid>
      </Grid>  
        <Grid>

          <MenuGroupIcon onClick={(e) => setAnchorEl(e.currentTarget)} />
          <Menu
            open={open}
            anchorEl={anchorEl}
            onClose={() => setAnchorEl(null)}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            disableAutoFocusItem
            sx={{...styled('menu', 'sx'),  '& .MuiList-root': { gap: 1 }}}
            slotProps={styled('menu', 'slotProps')}
          >
            {servicesList.map(({ title, note, name }, index) => (
              <MenuItem 
                key={index} 
                selected={currentServiceId === index}
                onClick={() => handleMenuChange(index, name)}
              >
                <Grid sx={{ display: 'flex', gap: 1.5, alignItems: 'center', py: 0.5 }}>
                  <D24MenuIcon />
                  <Grid sx={{ minWidth: 0, flex: 1 }}>
                    <Typography sx={{ fontWeight: 700, fontSize: 14 }}>{title}</Typography>
                    <Typography sx={{ color: theme.palette.grey.main, fontSize: 14 }}>{note}</Typography>
                  </Grid>
                </Grid>
              </MenuItem>
            ))}
          </Menu>
        </Grid> 
    </Grid>
    <Typography variant='h3' fontWeight={900}>{title}</Typography>
  </Box>
  )
}

export default LoginHeader